export default __webpack_public_path__ + "static/media/10.841a1ddf.jpg";